import { joinValidStrings, truncate } from './string';
import { formatYear } from './format-publication-data';
import { tuncatedLastNameList } from './format-author';

export const formatDescription = ({
  year, authors, source, abstract
}) => {
  const yearAndAuthors = joinValidStrings([
    formatYear(year),
    tuncatedLastNameList(authors)
  ], ' ');

  return joinValidStrings([
    yearAndAuthors,
    source,
    truncate(abstract, 200)
  ], '. ');
};

// Max length is 70
// 11  | Mendeley
// 18 ... & related info
// 41 available
const TITLE_LIMIT = 41;
const PREVIEW_TEXT = '& related info';
export const formatTitle = (title) => {
  if (!title) return undefined;

  return title.length > TITLE_LIMIT
    ? `${title.substring(0, TITLE_LIMIT)}... ${PREVIEW_TEXT}`
    : `${title} - ${PREVIEW_TEXT}`;
};



// WEBPACK FOOTER //
// ./src/universal/ui/utils/meta-tags.js